// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"276":"server-settings","287":"core-roles","437":"core-account","483":"issue-tracker-tasks","497":"core-users"}[chunkId] || chunkId) + "-legacy." + {"276":"ba5678f5","287":"532b08cd","437":"42dfbff0","483":"3b552ba9","497":"236bc006","979":"56e73ffe"}[chunkId] + ".js";
};